"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    padding: ", "em\n        ", "em;\n    text-align: ", ";\n    font-weight: ", ";\n    cursor: pointer;\n    position: relative;\n    ", ";\n"], ["\n    padding: ", "em\n        ", "em;\n    text-align: ", ";\n    font-weight: ", ";\n    cursor: pointer;\n    position: relative;\n    ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n                  color: ", ";\n                  background: ", ";\n              "], ["\n                  color: ", ";\n                  background: ", ";\n              "]),
    _templateObject3 = _taggedTemplateLiteral(["\n                  color: ", ";\n                  background: ", ";\n                  border-color: ", ";\n                  border-width: ", ";\n                  border-bottom-style: solid;\n              "], ["\n                  color: ", ";\n                  background: ", ";\n                  border-color: ", ";\n                  border-width: ", ";\n                  border-bottom-style: solid;\n              "]),
    _templateObject4 = _taggedTemplateLiteral(["\n    right: 0;\n    top: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n"], ["\n    right: 0;\n    top: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactCollapse = require("react-collapse");

var _icon = require("../icon");

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AccordionItem = _styledComponents2.default.div(_templateObject, function (props) {
    return props.theme.tabordion.padding / 2;
}, function (props) {
    return props.theme.tabordion.padding;
}, function (props) {
    return props.theme.tabordion.accordion.textAlign;
}, function (props) {
    return props.theme.tabordion.fontWeight;
}, function (props) {
    return props.current == props.i ? (0, _styledComponents.css)(_templateObject2, function (props) {
        return props.theme.tabordion.active.color;
    }, function (props) {
        return props.theme.tabordion.active.background;
    }) : (0, _styledComponents.css)(_templateObject3, function (props) {
        return props.theme.tabordion.default.color;
    }, function (props) {
        return props.theme.tabordion.default.background;
    }, function (props) {
        return props.theme.tabordion.borderColor;
    }, props.theme.tabordion.borderThickness);
});

var Twisty = _styledComponents2.default.div(_templateObject4);

var AccordionContent = function (_React$Component) {
    _inherits(AccordionContent, _React$Component);

    function AccordionContent() {
        _classCallCheck(this, AccordionContent);

        return _possibleConstructorReturn(this, (AccordionContent.__proto__ || Object.getPrototypeOf(AccordionContent)).apply(this, arguments));
    }

    _createClass(AccordionContent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                rest = _objectWithoutProperties(_props, ["children"]);

            return _react2.default.createElement(
                AccordionItem,
                rest,
                _react2.default.createElement(
                    Twisty,
                    null,
                    _react2.default.createElement(_icon2.default, {
                        name: this.props.current == this.props.i ? this.props.theme.tabordion.twisty.activeIcon : this.props.theme.tabordion.twisty.nonActiveIcon
                    })
                ),
                children
            );
        }
    }]);

    return AccordionContent;
}(_react2.default.Component);

exports.default = (0, _styledComponents.withTheme)(AccordionContent);


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/accordion/accordionHeader.js
// module id = 448
// module chunks = 95715928098905 168707334958949